import { ReadOnlyValue } from '@/shared/components';
import type { BookingResponse } from '@/shared/api';
import { Collapsible } from './Collapsible';
import { channelName } from './helpers';

// Technische Sync-Spur (IDs + CC-Hinweis), zugeklappt am Fuss der Detail-Ansicht.
export function ChannexSyncCollapsible({ booking }: { booking: BookingResponse }) {
  const channel = booking.source === 'Ota' ? channelName(booking.channel) : 'Manuell';
  const summary = booking.channexBookingId
    ? `${booking.channexBookingId.slice(0, 8)}… · ${channel}`
    : channel;

  return (
    <Collapsible icon="Database" title="Technische Details · Kanal-IDs" summary={summary}>
      <dl className="divide-hairline divide-y">
        <ReadOnlyValue label="Buchungs-ID" value={booking.id} mono copyable={booking.id} />
        {booking.channexBookingId && (
          <ReadOnlyValue
            label="Kanalmanager-ID"
            value={booking.channexBookingId}
            mono
            copyable={booking.channexBookingId}
          />
        )}
        <ReadOnlyValue label="Kanal" value={channel} />
      </dl>
      {booking.hasGuestCreditCard && (
        <p className="text-ink-soft border-hairline mt-3 border-t pt-3 text-xs leading-relaxed">
          Der Gast hat über {channel} Kreditkarten&shy;daten hinterlegt. Wir speichern sie nicht
          (PCI-Scope) — Zahlung ggf. direkt im {channel}-Extranet abwickeln.
        </p>
      )}
    </Collapsible>
  );
}
